/** The memory frame on a plan without the knowledge graph: says so in place of the globe. */
import { Button } from "@/components/ui";
import { useT } from "@/i18n";
import { framesMemoryMessages } from "@/i18n/messages/frames-memory";
import { isTauri } from "@/lib/is-tauri";
import {
  KNOWLEDGE_GRAPH_UPGRADE,
  openWebBillingSettings,
} from "@/lib/upgrade-toast";
import { useDesktopMode } from "@/stores/desktop-mode-store";

export function MemoryProOnly() {
  const t = useT(framesMemoryMessages);
  return (
    <div
      className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center"
      data-testid="memory-pro-only"
    >
      <p className="text-appkit-body text-muted">
        {KNOWLEDGE_GRAPH_UPGRADE.title}
      </p>
      <Button
        variant="secondary"
        size="sm"
        onClick={() =>
          isTauri()
            ? useDesktopMode.getState().requestSettings({ page: "account" })
            : openWebBillingSettings()
        }
        data-testid="memory-pro-only-upgrade"
      >
        {t("upgrade")}
      </Button>
    </div>
  );
}
